import ColorModeContext from '@/contexts/colorModeContext';
import {useBrand} from '@/contexts/BrandContext';
import {
  CssBaseline,
  PaletteMode,
  StyledEngineProvider,
  ThemeProvider as MuiThemeProvider,
} from '@mui/material';
import {createArkTheme} from '@ark/web';
import React from 'react';

export const ThemeProvider = ({children}: {children: React.ReactNode}) => {
  const {accent} = useBrand();
  const [mode, setMode] = React.useState<PaletteMode>(() => {
    const stored = localStorage.getItem('mode');
    return stored === 'light' || stored === 'dark' ? stored : 'light';
  });

  React.useLayoutEffect(() => {
    localStorage.setItem('mode', mode);
    document.documentElement.setAttribute('data-mui-color-scheme', mode);
  }, [mode]);

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode(prevMode => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );

  const theme = React.useMemo(
    () => createArkTheme({mode, accent}),
    [mode, accent],
  );

  return (
    <StyledEngineProvider injectFirst>
      <ColorModeContext.Provider value={colorMode}>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          {children}
        </MuiThemeProvider>
      </ColorModeContext.Provider>
    </StyledEngineProvider>
  );
};
